import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  
  MdPerson,
  MdHome,
  MdLock,
  MdDesignServices,
  MdPermContactCalendar,
  MdOutlineHomeWork,
  MdOutlineShoppingCart,
  MdDiscount,
  MdSettings,
  MdSupport,
  MdListAlt,
  MdHolidayVillage,
} from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { TbZoomQuestion } from "react-icons/tb";
// Admin Imports
import MainDashboard from "views/admin/default";
import AiDashboard from "views/admin/AiDashboard";
import AiSetting from "views/AiSetting";
import Profile from "views/admin/profile";
import users from "views/admin/Users";
import role from "views/admin/Role";
import settings from "views/admin/setting";
import Branch from "views/Branch/index";
import Company from "views/Company/index";
import BranchServices from "views/BranchServices/index";
import Order from "views/Order/index";
import Promotion from "views/Promotion/index";
import SignInCentered from "views/auth/signIn";
import Client from "views/Clients";
import Documents from "views/Documents/index";
import Feedback from "views/Feedback/index";
import Faq from "views/Faq/index";
import Chat from "views/Chat/index";
import Tickets from "views/Tickets/index";
import { IoDocumentText } from "react-icons/io5";
import { IoMdChatbubbles } from "react-icons/io";
import Logs from "views/Logs/index";
import Holidays from "views/Holidays";

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "/Main Dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    name: "Service Provider",
    layout: "/admin",
    path: "/company",
    icon: <Icon as={HiOutlineBuildingOffice2} width='20px' height='20px' color='inherit' />,
    component: Company,
  },
  {
    name: "Branch",
    layout: "/admin",
    path: "/branch",
    icon: <Icon as={MdOutlineHomeWork} width='20px' height='20px' color='inherit' />,
    component: Branch,
  },
  {
    name: "Services",
    layout: "/admin",
    path: "/services",
    icon: <Icon as={MdDesignServices} width='20px' height='20px' color='inherit' />,
    component: BranchServices,
  },
  {
    name: "Orders",
    layout: "/admin",
    path: "/orders",
    icon: <Icon as={MdOutlineShoppingCart} width='20px' height='20px' color='inherit' />,
    component: Order,
  },
  // {
  //   name: "Delivery",
  //   layout: "/admin",
  //   path: "/delivery",
  //   icon: <Icon as={MdDeliveryDining} width='20px' height='20px' color='inherit' />,
  //   component: Delivery,
  // },
  {
    name: "Promotions",
    layout: "/admin",
    path: "/Promotions",
    icon: <Icon as={MdDiscount } width='20px' height='20px' color='inherit' />,
    component: Promotion,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "/profile",
    icon: <Icon as={MdPerson} width='20px' height='20px' color='inherit' />,
    component: Profile,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "/sign-in",
    icon: <Icon as={MdLock} width='20px' height='20px' color='inherit' />,
    component: SignInCentered,
  },
  {
    name: "Users",
    layout: "/admin",
    path: "/users",
    icon: <Icon as={MdPermContactCalendar} width='20px' height='20px' color='inherit' />,
    component: users,
  },
  {
    name: "Role",
    layout: "/admin",
    path: "/Role",
    icon: <Icon as={MdPermContactCalendar} width='20px' height='20px' color='inherit' />,
    component: role,
  },
  {
    name: "Reference Data",
    layout: "/admin",
    path: "/Reference Data",
    icon: <Icon as={MdPermContactCalendar} width='20px' height='20px' color='inherit' />,
    component: settings,
  },
  {
    name: "AI Dashboard",
    layout: "/admin",
    path: "/Ai Dashboard",
    icon: <Icon as={MdHome} width='20px' height='20px' color='inherit' />,
    component: AiDashboard,
  },
  {
    name: "Clients",
    layout: "/admin",
    path: "/clients",
    icon: <Icon as={MdPermContactCalendar} width='20px' height='20px' color='inherit' />,
    component: Client,
  },
  {
    name: "Documents",
    layout: "/admin",
    path: "/documents",
    icon: <Icon as={IoDocumentText} width='20px' height='20px' color='inherit' />,
    component: Documents,
  },
  {
    name: "Feedback",
    layout: "/admin",
    path: "/feedback",
    icon: <Icon as={VscFeedback} width='20px' height='20px' color='inherit' />,
    component: Feedback,
  },
  {
    name: "Faq",
    layout: "/admin",
    path: "/faq",
    icon: <Icon as={TbZoomQuestion} width='20px' height='20px' color='inherit' />,
    component: Faq,
  },
  {
    name: "Chat",
    layout: "/admin",
    path: "/chat",
    icon: <Icon as={IoMdChatbubbles} width='20px' height='20px' color='inherit' />,
    component: Chat,
  },
  {
    name: "Tickets",
    layout: "/admin",
    path: "/tickets",
    icon: <Icon as={MdSupport} width='20px' height='20px' color='inherit' />,
    component: Tickets,
  },
  {
    name: "Holidays",
    layout: "/admin",
    path: "/holidays",
    icon: <Icon as={MdHolidayVillage} width='20px' height='20px' color='inherit' />,
    component: Holidays,
  },
   {
    name: "Logs",
    layout: "/admin",
    path: "/logs",
    icon: <Icon as={MdListAlt} width='20px' height='20px' color='inherit' />,
    component: Logs,
  },
  {
    name: "AiSetting",
    layout: "/admin",
    path: "/aisetting",
    icon: <Icon as={MdSettings} width='20px' height='20px' color='inherit' />,
    component: AiSetting,
  },
];

export default routes;
